import { useLayoutEffect } from 'react';

export const DEFAULT_TITLE = 'Giga Group';
export const DEFAULT_DESCRIPTION =
    'Giga Group is a leading real estate developer in Pakistan, DHA Phase 2 Islamabad. Offering a variety of residential and commercial projects with 70+ years of excellence.';

const upsertMeta = (attr, key, content) => {
    let element = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!content) {
        if (element) element.remove();
        return;
    }
    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, key);
        document.head.appendChild(element);
    }
    element.setAttribute('content', content);
};

const upsertLink = (rel, href) => {
    if (!href) return;
    let element = document.head.querySelector(`link[rel="${rel}"]`);
    if (!element) {
        element = document.createElement('link');
        element.setAttribute('rel', rel);
        document.head.appendChild(element);
    }
    element.setAttribute('href', href);
};

const upsertJsonLd = (data) => {
    let element = document.getElementById('seo-jsonld');
    if (!data) {
        if (element) element.remove();
        return;
    }
    if (!element) {
        element = document.createElement('script');
        element.id = 'seo-jsonld';
        element.type = 'application/ld+json';
        document.head.appendChild(element);
    }
    element.textContent = JSON.stringify(data);
};

const toAbsoluteUrl = (value) => {
    if (!value) return '';
    if (/^https?:\/\//i.test(value)) return value;
    return `${window.location.origin}${value.startsWith('/') ? value : `/${value}`}`;
};

export const applySeo = ({
    title = DEFAULT_TITLE,
    description = DEFAULT_DESCRIPTION,
    keywords,
    image,
    type = 'website',
    canonical,
    exactTitle = false,
} = {}) => {
    const fullTitle = exactTitle && title
        ? title
        : !title || title === DEFAULT_TITLE
            ? DEFAULT_TITLE
            : /giga group/i.test(title)
                ? title
                : `${title} | Giga Group`;
    const desc = description || DEFAULT_DESCRIPTION;
    const canonicalUrl = toAbsoluteUrl(canonical || window.location.pathname.split('#')[0]);
    const imageUrl = image ? toAbsoluteUrl(image) : '';

    document.title = fullTitle;
    upsertMeta('name', 'description', desc);
    upsertMeta('name', 'keywords', keywords);
    upsertMeta('property', 'og:site_name', 'Giga Group');
    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', desc);
    upsertMeta('property', 'og:url', canonicalUrl);
    upsertMeta('property', 'og:type', type);
    upsertMeta('name', 'twitter:card', imageUrl ? 'summary_large_image' : 'summary');
    upsertMeta('name', 'twitter:title', fullTitle);
    upsertMeta('name', 'twitter:description', desc);
    upsertLink('canonical', canonicalUrl);

    if (imageUrl) {
        upsertMeta('property', 'og:image', imageUrl);
        upsertMeta('name', 'twitter:image', imageUrl);
    }

    upsertJsonLd({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: fullTitle,
        description: desc,
        url: canonicalUrl,
        ...(imageUrl ? { image: imageUrl } : {}),
        isPartOf: {
            '@type': 'WebSite',
            name: 'Giga Group',
            url: window.location.origin,
        },
    });
};

const Seo = ({ title, description, keywords, image, type, canonical, exactTitle }) => {
    useLayoutEffect(() => {
        applySeo({ title, description, keywords, image, type, canonical, exactTitle });

        return () => {
            applySeo();
        };
    }, [title, description, keywords, image, type, canonical, exactTitle]);

    return null;
};

export default Seo;
